import { render, staticRenderFns } from "./TabNotations.vue?vue&type=template&id=028e4312&scoped=true&"
import script from "./TabNotations.vue?vue&type=script&lang=js&"
export * from "./TabNotations.vue?vue&type=script&lang=js&"
import style0 from "./TabNotations.vue?vue&type=style&index=0&id=028e4312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e4312",
  null
  
)

export default component.exports